module.exports = __webpack_public_path__ + "static/media/camp4.73fa4c8e.jpeg";